import type { ScreenSchema } from './types';

/**
 * Schema for the `sticky-left` and `sticky-right` templates.
 *
 * Both are rendered by screen-sticky.vue, which orchestrates audio across its
 * child left/right screens using ScrollTrigger callbacks. `managesOwnSectionAudio`
 * prevents uc-screen's generic sectionActive watcher from firing separately.
 *
 * Audio behaviour (managed by screen-sticky.vue):
 *   sticky-left  — plays the first left screen's intro, queues the first right
 *                  screen's intro; subsequent right screens play per ScrollTrigger
 *   sticky-right — plays each left (scrolling) screen's intro per ScrollTrigger
 *
 * The actual audio content for each child screen comes from that child screen's
 * own schema, resolved via useChildScreenAudio().resolveChildIntro().
 */
const stickySchema: ScreenSchema = {
  template: ['sticky-left', 'sticky-right'],
  managesOwnSectionAudio: true,
  slots: {}
};

export default stickySchema;
